import './scss/app.scss';

import { iconCartPosition } from './js/iconCartPosition';
import { controlsBannerVideo } from './js/controlsBannerVideo';
import { accordion } from './js/accordion';
import { addToCart } from './js/addToCart';
import {
	initGallery,
	sliderBundlesRelated,
	sliderSingleBlog,
} from './js/gallerySingle';
/* import { batchSliderTimeLine } from './js/batchSliderTimeLine'; */

import { cartPage as InitCartPage } from './js/cartPage';
import { checkoutPage as initCheckoutPage } from './js/checkoutPage';
import { orderDetailPage as initOrderDetailPage } from './js/orderDetailPage';
import { loginPage as initLoginPage } from './js/loginPage';

import { accountPage as initAccountPage } from './js/accountPage';

import { initBlog } from './js/blog';

/* eslint-disable */
const domContentLoaded = () => {
	iconCartPosition();

	const buttonsVideo = document.querySelectorAll('[data-video="control"]');
	if (buttonsVideo) {
		buttonsVideo.forEach(button => {
			const video = button.closest('section');
			controlsBannerVideo({
				element: button,
				video: video.querySelector('[data-video="src"]')
			})
		})
	}

	window.initAccordion = () => {
		accordion();
	}

	window.initAccordion();

	/*addToCart()*/

	// filter with radio buttons
	const filterRadio = document.querySelectorAll('form [name="filter"]');
	if (filterRadio) {
		const filterArticles = target => {
			const articles = document.querySelectorAll('article');
			if (!articles) return;
			articles.forEach(article => {
				const data = article.dataset;
				const { type } = data;
				article.classList.add('animate-hidden');
				setTimeout(() => {
					article.classList.add('hidden');
					if (type === target || target === 'all' || (!type && target === 'bundles')) {
						article.classList.remove('animate-hidden');
						article.classList.remove('hidden');
					} else {
						article.classList.add('animate-hidden');
					}
				}, 350);
			})
		}
		filterRadio.forEach(radio => {
			radio.addEventListener('change', e => {
				const target = e.target.value;
				filterArticles(target);
			})
		})

		const bundleSelected = document.querySelector('#filter-bundles');
		if (bundleSelected && bundleSelected.checked) {
			filterArticles('bundles');
		}
	}

	// init single gallery
	initGallery();

	sliderBundlesRelated()

	sliderSingleBlog()

	// show fixed price
	const fixedPrice = document.querySelector('[ref="fixedPrice"]');
	if (fixedPrice) {
		// mostrar al hacer scroll down mas de 100px
		window.addEventListener('scroll', () => {
			const scroll = window.scrollY;
			if (scroll > 400) {
				fixedPrice.classList.remove('translate-y-full');
			} else {
				fixedPrice.classList.add('translate-y-full');
			}
		})
	}

	InitCartPage();

	initCheckoutPage();

	initOrderDetailPage();

	initLoginPage();

	initAccountPage();

	initBlog();

	const batchSlider = document.querySelector('.batches-slider');
	if (batchSlider) {
		import('./js/batchSliderTimeLine').then(module => {
			module.batchSliderTimeLine({ element: batchSlider });
		})
	}

	// check if the title tag on head HTML change
	const observer = new MutationObserver((mutationsList, observer) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'childList') {
				if (mutation.target.nodeName === 'TITLE') {
					const title = mutation.target.textContent;
					if (title.includes('||')) {
						const titleSplit = title.split('||');
						const titleFirst = titleSplit[0].trim();
						const titleSecond = titleSplit[1].trim();
						document.title = `${titleFirst} - ${titleSecond}`;
					}
				}
			}
		}
	});

	// Start observing the target node for configured mutations
	observer.observe(document.querySelector('head'), { childList: true, subtree: true });


	// check if pageUrl is /club/wine-club
	const pageUrl = window.location.pathname;
	if (pageUrl.includes('/club/wine-club')) {
		const loader = document.createElement('div');
		loader.classList = 'fixed-loader fixed inset-0 z-50 grid place-items-center w-full h-full backdrop-filter backdrop-blur-md';
		loader.insertAdjacentHTML('beforeend', `<span class="loader"></span><span class="sr-only">Loading...</span>`);
		document.body.appendChild(loader);
	}

	const isSingleWine = document.querySelector('.single-wine');
	if (isSingleWine) {
		import('./js/waitingForReviews').then(module => {
			module.waitingForReviews();
		})
	}
};
document.addEventListener('DOMContentLoaded', domContentLoaded());